import { createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["TooltipProvider"], null, {
    default: _withCtx(() => [
      _createVNode($setup["TooltipRoot"], null, {
        default: _withCtx(() => [
          _createVNode($setup["TooltipTrigger"], {
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click'))),
            class: "reset-button-tooltip__trigger"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["Pen"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode($setup["TooltipPortal"], null, {
            default: _withCtx(() => [
              _createVNode($setup["TooltipContent"], {
                class: "reset-button-tooltip__content",
                "side-offset": 4
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
              })
            ]),
            _: 3 /* FORWARDED */
          })
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }))
}